import styled from 'styled-components';

export const Container = styled.div`
  min-width: 400px;
  width: 100%;
`;

export const Text = styled.p`
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FieldWrapper = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.23);
  padding: 0.1rem 0.1rem;
  border-radius: 10px;
`;

export const FieldWrapperFile = styled.div`
  padding: 0.2rem 0.2rem;
`;

export const AreaFooterButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  width: 100%;

  > button {
    margin: 0;
  }
`;
